import { ChassisCrafting } from '@components/arsenal/forge/ChassisCrafting';
import { CompleteButton } from '@components/arsenal/forge/CompleteButton';
import { WeaponCrafting } from '@components/arsenal/forge/WeaponCrafting';
import { ItemCrafting } from '@components/arsenal/forge/ItemCrafting';
import { CraftButton } from '@components/arsenal/forge/CraftButton';
import { useAppStore } from '@stores';
import * as Shared from '@shared/lib';

interface ForgeItemProps {
  value: string;
  amount?: number;
  type: 'CHASSIS' | 'WEAPON' | 'ITEM';
};

export function ForgeItem({ value, amount, type }: ForgeItemProps) {
  const { userData } = useAppStore();

  const data = {
      CHASSIS: Shared.chassisData,
      WEAPON: Shared.weaponsData,
      ITEM: Shared.itemData,
    }[type].find((c) => c.key === value);
  if (!data) return null;

  const blueprint = userData.blueprints
    .find(b => b.key === value && b.type === type);
  if (!blueprint) return null;

  const crafting = data.crafting;
  if (!crafting) return null;

  const canForge = !blueprint.finishesAt && Object
    .entries(crafting.resources)
    .every(([key, value]) => (userData.items.find(i => i.key === key)?.amount ?? 0) >= value);
  const canComplete = blueprint.finishesAt && new Date(blueprint.finishesAt).getTime() <= Date.now();
  const showSuccess = canForge || canComplete;

  return (
    <div className={`${showSuccess && 'border-primary border-b'} market-listing`}>
      {type === 'CHASSIS' && (
        <ChassisCrafting finishesAt={blueprint.finishesAt} chassis={value} />
      )}
      {type === 'WEAPON' && (
        <WeaponCrafting finishesAt={blueprint.finishesAt} weapon={value} />
      )}
      {type === 'ITEM' && (
        <ItemCrafting finishesAt={blueprint.finishesAt} amount={amount} item={value} />
      )}

      {!blueprint.finishesAt && (
        <CraftButton resources={crafting.resources} id={blueprint.id} />
      )}
      {blueprint.finishesAt && (
        <CompleteButton finishesAt={blueprint.finishesAt} id={blueprint.id} />
      )}
    </div>
  );
}